import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from './plugins/i18n'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import 'animate.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'swiper/css/bundle'
import AOS from 'aos'
import 'aos/dist/aos.css'
import axios from 'axios'

// 🔗 API baseURL ayarı
const baseURL = process.env.VUE_APP_API_URL
axios.defaults.baseURL = `${baseURL}`
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (error) => Promise.reject(error))

// ✅ Google Analytics 4 entegrasyonu
const GA_MEASUREMENT_ID = 'G-3H4CGWT6L5'

// GA4 scriptini yükle
const gaScript = document.createElement('script')
gaScript.async = true
gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
document.head.appendChild(gaScript)

// GA fonksiyonları tanımla
window.dataLayer = window.dataLayer || []
function gtag() {
  window.dataLayer.push(arguments)
}
gtag('js', new Date())
gtag('config', GA_MEASUREMENT_ID)

// ✅ Sayfa değişimlerinde GA4’e gönder
router.afterEach((to) => {
  gtag('config', GA_MEASUREMENT_ID, {
    page_path: to.fullPath
  })
})

// App başlat
const app = createApp(App)

// AOS başlat
AOS.init({
  duration: 800,
  once: true,
  easing: 'ease-in-out',
  offset: 120
})

// Pluginler
app.use(createPinia())
app.use(VueTelInput)
app.use(router)
app.use(i18n)

app.mount('#app')
